import React, { useRef, useEffect } from 'react'

function PinInput({ value, onChange, disabled }) {
  const inputs = useRef([])
  const digits = value.split('')

  // Clear any browser-autofilled values on mount
  useEffect(() => {
    inputs.current.forEach(el => { if (el) el.value = '' })
  }, [])

  const handleKey = (e, idx) => {
    if (e.key === 'Backspace') {
      if (digits[idx]) {
        const next = [...digits]
        next[idx] = ''
        onChange(next.join(''))
      } else if (idx > 0) {
        inputs.current[idx - 1]?.focus()
        const next = [...digits]
        next[idx - 1] = ''
        onChange(next.join(''))
      }
    }
  }

  const handleChange = (e, idx) => {
    const val = e.target.value.replace(/\D/g, '').slice(-1)
    if (!val) return
    const next = [...digits]
    next[idx] = val
    onChange(next.join(''))
    if (idx < 5) inputs.current[idx + 1]?.focus()
  }

  return (
    <div className="flex gap-2 justify-center">
      {Array.from({ length: 6 }).map((_, idx) => (
        <input
          key={idx}
          ref={el => { inputs.current[idx] = el }}
          type="password"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={1}
          autoComplete="new-password"
          value={digits[idx] || ''}
          onChange={e => handleChange(e, idx)}
          onKeyDown={e => handleKey(e, idx)}
          onFocus={e => e.target.select()}
          disabled={disabled}
          className="w-10 h-12 text-center text-lg font-bold bg-bg-dark border border-border-dark rounded focus:outline-none focus:border-accent-teal text-white disabled:opacity-50"
        />
      ))}
    </div>
  )
}

export default PinInput
